<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <h1 class="mb-6 text-2xl font-bold md:text-4xl">
    {{ title }}
  </h1>
</template>
